import React from 'react';
import { Chip } from '@material-ui/core';

import UltimaAccionImpresion from '../UltimaAccionImpresion/UltimaAccionImpresion';

/** Estados que calcula el backend (Anulado tiene prioridad; si no, Descargado o Pendiente según Cancelado_Desc). */
export const estadosComprobante = {
  Pendiente: { nombre: 'Pendiente', color: '#f5c518', textColor: '#000000' },
  Descargado: { nombre: 'Descargado', color: '#2e7d32', textColor: '#ffffff' },
  Anulado: { nombre: 'Anulado', color: '#d32f2f', textColor: '#ffffff' }
};

/** Chip de color con el estado (nombre de estadosComprobante); nada si no es un estado conocido. */
export const EstadoComprobanteChip = ({ estado, style }) => {
  const datos = estadosComprobante[estado];
  if (!datos) return null;

  return (
    <Chip
      size="small"
      label={datos.nombre}
      style={{ backgroundColor: datos.color, color: datos.textColor, fontWeight: 'bold', ...style }}
    />
  );
};

/** Tag de color con el estado del comprobante y, debajo, lo último que se hizo con él. */
const EstadoComprobanteTag = ({ comprobante }) => {
  return (
    <React.Fragment>
      <EstadoComprobanteChip estado={comprobante.estado} style={{ marginBottom: '2px' }} />
      <UltimaAccionImpresion ultimaAccion={comprobante.ultimaAccion} />
    </React.Fragment>
  );
};

export default EstadoComprobanteTag;
